import React from "react";
import {useParams} from "react-router-dom";
import ProtectedContent from "../../../components/protectedContent";
import SafeView from "../../../components/safeView/SafeView";
import DeliveryLogsTable from "./deliveryLogsTable";
import "./deliveryLogs.scss";

const DeliveryLogs = () => {
  const {webhookId} = useParams();

  return (
    <SafeView>
      <ProtectedContent perms={[]} showFallback>
        <div className="delivery-logs--container">
          <DeliveryLogsTable webhookId={webhookId} />
        </div>
      </ProtectedContent>
    </SafeView>
  );
};

export default DeliveryLogs;
